module.exports = __webpack_public_path__ + "img/logo-LAT.18a9ba37.svg";